import { useDispatch } from 'react-redux';
import { clearStore } from '../features/user/userSlice';
import { useNavigate } from 'react-router-dom';

export function HandleUnauthorization(){
    const dispatch = useDispatch();
    const navigate = useNavigate();
    dispatch(clearStore())
    navigate('/login')
}